import React from 'react';
import { Pressable, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing, useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

interface Props {
  value: number;
  onChange: (rating: number) => void;
  size?: number;
}

export function StarRatingInput({ value, onChange, size = 30 }: Props) {
  const { colors } = useAppTheme();

  return (
    <View style={styles.row}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Pressable key={star} accessibilityRole="button" accessibilityLabel={`Rate ${star} star${star > 1 ? 's' : ''}`} onPress={() => onChange(star)} hitSlop={6}>
          <Ionicons name={star <= value ? 'star' : 'star-outline'} size={size} color={star <= value ? colors.star : colors.starMuted} />
        </Pressable>
      ))}
    </View>
  );
}

const styles = ScaledSheet.create({
  row: { flexDirection: 'row', gap: spacing.sm },
});
